import React from 'react';
// eslint-disable-next-line import/extensions
import CheckUserSegment from './CheckUserSegment';

const CheckUserSegmentDashboard: React.FC<{}> = () => {
	return <CheckUserSegment />;
};

export default CheckUserSegmentDashboard;
